<lib-insta-learn-topics-widget 
  [title]="data?.subTitle"
  [textColor]="data.defaultTextColor"
  [highlightColor]="data.highlightColor"
  [items]="items"
  [animation]="data?.animation"
  [animationDelay]="data?.animationDelay"
  (openTopic)="openDialog($event)">
</lib-insta-learn-topics-widget>
